import { post } from "shared/wrapper";

class AuthRepository {
  URL = "/api/auth/v1";

  constructor(url) {
    this.URL = url || this.URL;
  }

  login(params) {
    return post(`${this.URL}/login`, params);
  }

  changePassword(params) {
    return post(`${this.URL}/changePassword`, params);
  }
}

export default new AuthRepository();
